import React, { useState } from 'react';
import { Text } from 'components/Elements';
import { Logo } from 'components/Layout';
import { Share, X, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { MoreInfoModal } from './MoreInfoModal';

export const VisualizerNavbar = ({ onSearch }) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(searchValue);
    }
  };

  return (
    <>
      <div className="w-full rounded-3xl h-12 flex items-center justify-between px-5 bg-gray-900 text-white">
        <div className="flex flex-row items-center space-x-4">
          <button
            className="bg-gray-700 px-3 py-2 rounded-md"
            onClick={() => setIsModalOpen(true)}
          >
            More Info
          </button>
          <div className="relative">
            <input
              type="text"
              placeholder="Search for transaction ID, user or provider"
              className="bg-gray-800 text-white p-2 rounded-xl w-96 pl-10 outline-none"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Search size={20} className="absolute left-2 top-2 text-gray-400" />
          </div>
        </div>
        <div className="flex flex-row items-center space-x-2">
          <button
            onClick={() => alert('Share')}
            className="flex flex-row items-center space-x-2"
          >
            <Text>Share</Text>
            <Share size={12} />
          </button>
        </div>
      </div>
      {isModalOpen && <MoreInfoModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};
